import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20of%20floating%20fashion%20product%20silhouettes%20in%20warm%20cream%20oat%20and%20terracotta%20tones%2C%20soft%20gradient%20background%20with%20gentle%20organic%20shapes%2C%20modern%20minimalist%20aesthetic%2C%20clean%20editorial%20design%2C%20no%20text%2C%20elevated%20lifestyle%20concept%2C%20subtle%20texture%20overlay&width=1600&height=900&seq=hero-vigorbuy-2026-v3&orientation=landscape"
          alt="VigorBuy Spreadsheet curated product resources"
          className="w-full h-full object-cover object-center"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/45"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-10 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/30 bg-white/10 backdrop-blur-sm mb-6">
          <div className="w-1.5 h-1.5 rounded-full bg-accent-400"></div>
          <span className="text-xs md:text-sm text-white/90 font-medium tracking-wide">
            Updated Weekly &bull; 2026
          </span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading text-white leading-tight mb-6 max-w-4xl mx-auto">
          VigorBuy Spreadsheet 2026
        </h1>
        <p className="text-base md:text-lg text-white/80 leading-relaxed max-w-2xl mx-auto mb-8">
          Discover the latest curated product lists, guides &amp; buying resources. Explore updated
          product comparisons, shipping information, and safe shopping tips all in one place.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/article/vigorbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-white text-sm md:text-base font-medium rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            View Latest Spreadsheet
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3 bg-white/20 backdrop-blur-sm border border-white/40 text-white text-sm md:text-base font-medium rounded-full hover:bg-white/30 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Explore Product Categories
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-sm"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}